(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/pay/handle-pay.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/pay/handle-pay.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const currencyAsJupiterString = svs.utils.format.CurrencyAsJupiterString;
const {
  productMapping,
  rules
} = svs.numbergames;
const {
  constants: {
    PROLONG_WAGERS_PARAMS
  }
} = svs.numbergames.prolong_game.common;
const {
  trackClickPay,
  trackProlongIsDuplicate
} = svs.numbergames.prolong_game.analytics;
const showAlreadyProlongedDialogAsync = () => new Promise(resolve => {
  const dialog = new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'information',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.CONFIRM,
    title: 'Du har redan förlängt detta spel',
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: 'Är du säker på att du vill förlänga detta spel? Tänk på att det kan bli en dubblett.',
      align: svs.components.dialog.message.align.CENTER
    }],
    actions: [{
      type: svs.components.dialog.button.SECONDARY,
      title: 'Avbryt',
      callback: () => {
        resolve(false);
        dialog.close();
      }
    }, {
      type: svs.components.dialog.button.PRIMARY,
      title: 'Förläng',
      callback: () => {
        resolve(true);
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
});
const resetUrlParams = () => {
  Object.values(PROLONG_WAGERS_PARAMS).forEach(key => svs.utils.paramHandler.remove({
    key
  }));
};
const getAPIWagers = _ref => {
  let {
    wager,
    isSystemWager,
    totalDrawCount,
    selectedDays,
    drawCount,
    rowCount
  } = _ref;
  const boardNames = {
    KENO: 'kenoBoards',
    LOTTO: 'lottoBoards',
    EUROJACKPOT: 'extNumberBoards',
    VIKINGLOTTO: 'extNumberBoards',
    JOKER: 'jokerBoards'
  };
  const calculateBetAmountFromSalesGroup = betAmountSalesGroup => currencyAsJupiterString(parseInt(betAmountSalesGroup, 10) / totalDrawCount * drawCount);
  const calculateBetAmount = bet => {
    if (productMapping.isLotto(bet.productId)) {
      const hasLotto2 = Boolean(parseInt(bet.betAmountSalesGroup2, 10));
      const rowPrice = rules.getRules(bet.productId).rowPrice;
      const betAmountSalesGroup1 = currencyAsJupiterString(rowPrice * rowCount * drawCount);
      const betAmountSalesGroup2 = hasLotto2 ? betAmountSalesGroup1 : bet.betAmountSalesGroup2;
      return {
        betAmountSalesGroup1,
        betAmountSalesGroup2
      };
    }
    return {
      betAmountSalesGroup1: calculateBetAmountFromSalesGroup(bet.betAmountSalesGroup1),
      betAmountSalesGroup2: calculateBetAmountFromSalesGroup(bet.betAmountSalesGroup2)
    };
  };
  return selectedDays.map(productItsId => ({
    bagType: 0,
    bets: wager.bets.map(bet => {
      const boardName = boardNames[productMapping.getProductId(bet.productId)];
      const {
        betAmountSalesGroup1,
        betAmountSalesGroup2
      } = calculateBetAmount(bet);
      return {
        productId: productMapping.isJoker(bet.productId) ? productMapping.getJokerProductId(productItsId) : productItsId,
        numDraws: drawCount,
        betProperties: ['PROLONGATION'],
        betAmountSalesGroup1,
        betAmountSalesGroup2,
        rowPriceMulti: bet.rowPriceMulti,
        [boardName]: bet[boardName].map(board => _objectSpread(_objectSpread(_objectSpread({
          rowPriceMulti: board.rowPriceMulti,
          boardProps: [],
          systemType: isSystemWager ? ['MSYS'] : ['SROW'],
          participation: productMapping.isLotto(bet.productId) || productMapping.isKeno(bet.productId) ? board.participation : 0
        }, board.boardData && {
          boardData: board.boardData
        }), board.boardData1 && {
          boardData1: board.boardData1
        }), board.boardData2 && {
          boardData2: board.boardData2
        }))
      };
    })
    .sort((a, b) => productMapping.isJoker(a) - productMapping.isJoker(b))
  }));
};
const handlePay = async (prolongContext, isRestartedPayment) => {
  const {
    wager: {
      wagerId,
      productName,
      wager,
      isSystemWager,
      totalDrawCount,
      rowCount,
      lastDrawDate
    },
    drawCount: drawCountString,
    price,
    selectedDays,
    onSuccessCb,
    onDoneCb,
    onCancelCb
  } = prolongContext;
  const product = productMapping.getProductId(productName);
  const drawCount = parseInt(drawCountString, 10);
  if (!isRestartedPayment) {
    let existingProlong = false;
    if (svs.core.detect.feature('ft-lyckoplatsen-new-prolong')) {
      const {
        timestamp
      } = await svs.tur.prolongStorage.get({
        wagerId,
        productId: product
      });
      existingProlong = Boolean(timestamp);
    } else {
      existingProlong = svs.components.Storage.browser.get(wagerId, 'numbergameProlong');
    }
    if (existingProlong) {
      const duplicateProlong = await showAlreadyProlongedDialogAsync();
      trackProlongIsDuplicate(duplicateProlong, prolongContext);
      if (!duplicateProlong) {
        return;
      }
    }
    const isWagerUnchanged = drawCount === totalDrawCount && selectedDays.every(day => productMapping.isSameProduct(day, productName));
    trackClickPay(isWagerUnchanged, prolongContext);
  }
  const saveState = redirectCallback => {
    const {
      prolong,
      prepCount,
      prepDays,
      prepId
    } = PROLONG_WAGERS_PARAMS;
    svs.utils.paramHandler.set({
      key: prolong,
      value: true
    });
    svs.utils.paramHandler.set({
      key: prepId,
      value: wagerId
    });
    svs.utils.paramHandler.set({
      key: prepCount,
      value: drawCountString
    });
    if (productMapping.isProductFamily(product)) {
      svs.utils.paramHandler.set({
        key: prepDays,
        value: selectedDays.join('-')
      });
    }
    redirectCallback();
  };
  const onSuccessCallback = args => {
    resetUrlParams();
    onSuccessCb === null || onSuccessCb === void 0 || onSuccessCb(args);
  };
  const onCancelCallback = () => {
    resetUrlParams();
    onCancelCb === null || onCancelCb === void 0 || onCancelCb();
  };
  svs.numbergames.pay_numbergames.makePayment({
    onSuccessCb: onSuccessCallback,
    onDoneCb,
    onCancelCallback,
    saveState,
    wagerData: {
      product,
      price,
      drawCount,
      prolongedWagerId: wagerId,
      lastDrawDate,
      wagers: getAPIWagers({
        wager,
        isSystemWager,
        totalDrawCount,
        selectedDays,
        drawCount,
        rowCount
      })
    }
  });
};
setGlobal('svs.numbergames.prolong_game.pay.handlePay', handlePay);

 })(window);